<template>
  <div class="my-gift">
    <van-tabs v-model="active"
              sticky
              color="#388BFF"
              titleActiveColor="#388BFF"
              @change="changeTab" >
      <van-tab title="Purchased" name="notGift">
        <van-list v-if="notGiftedItems.length > 0" :immediate-check="false" class="list" v-model="loading" :finished="finished" finished-text="The end" @load="onLoad">
          <van-card
            v-for="item in notGiftedItems" :key="item.orderId"
            :title="item.orderName"
            :tag="item.orderStatus | status"
            :thumb="item.orderUrlImage || 'https://ebuyimg.e-mallchina.com/olvp/autocard.png'"
          >
            <template #tags>
              <p class="gray">{{item.createDate | dateFormat('minute', '/')}}</p>
              <!-- <p>
                {{item.currency | unitFormat}}{{item.totalAmount | numFormat(2)}}
              </p> -->
            </template>
            <template #footer>
              <van-button type="info" size="small" round plain v-if="item.orderStatus !== 'Init'"
                @click="onOrderTap('detail', item.orderId, 'notGift')">
                Order Info
              </van-button>
              <van-button type="info" size="small" round v-if="item.orderStatus !== 'Paid' && item.orderStatus !== 'Init'"
                @click="onOrderTap('gift', item.orderId, 'notGift')">Gift it</van-button>
                <van-button type="info" size="small" round v-if="item.orderStatus === 'Init'"
                @click="onOrderTap('detail', item.orderId, 'notGift')">To Pay</van-button>
            </template>
          </van-card>
        </van-list>
        <data-nothing v-if="!listLoading && notGiftedItems.length === 0" type="order"></data-nothing>
      </van-tab>
            <van-tab title="Sent" name="sent">
          <div v-if="transferItems.length > 0" class="list">
            <van-card
              v-for="item in transferItems" :key="item.orderId"
              :title="item.orderName"
              :tag="item.packageStatus | packageStatus"
              :thumb="item.packageImage || 'https://ebuyimg.e-mallchina.com/olvp/autocard.png'"
            >
              <template #tags>
                <p class="gray time">{{Number(item.createDate) | dateFormat('minute', '/')}}</p>
              </template>
              <template #footer>
                <van-button type="info" size="small" round plain v-if="item.orderId"
                @click="onOrderTap('detail', item.orderId, 'sent')">Order Info</van-button>
                <van-button type="info" size="small" round
                    v-if="item.packageStatus === 'DELIVERING' && item.shortLink !== 'GiveMySelf'"
                    data-clipboard-action="copy"
                    class="copytext"
                    :data-clipboard-text="`Here's a present for you! ` + item.shortLink"
                    @click="onCopyTap(item.shortLink)">Copy URL</van-button>
              </template>
            </van-card>
            <p class="the-end">The end</p>
          </div>
        <data-nothing v-else type="gift"></data-nothing>
      </van-tab>
      <van-tab title="Received" name="received">
          <div class="list" v-if="receiveItems.length > 0">
            <van-card
              v-for="item in receiveItems" :key="item.orderId"
              :title="item.orderName"
              :tag="item.from"
              :thumb="item.packageImage || 'https://ebuyimg.e-mallchina.com/olvp/autocard.png'"
            >
              <template #tags>
                <p class="gray time">{{Number(item.createDate) | dateFormat('minute', '/')}}</p>
              </template>
              <template #footer>
                <van-button type="info" size="small" round plain
                  @click="onCheckTap(item)">Coupons</van-button>
              </template>
            </van-card>
            <p class="the-end">The end</p>
          </div>
        <data-nothing v-else type="gift"></data-nothing>
      </van-tab>
    </van-tabs>
    <van-dialog v-model="giftDialog" :closeOnClickOverlay="true" confirmButtonText="Check Coupons" @confirm="checkCoupons">
      <div class="gift-dialog">
        <div class="fx fx-center fx-items-center friend" v-if="dialogData.memberId !== localMemberId">
          <img v-if="dialogData.profilePhotoUrl" :src="dialogData.profilePhotoUrl">
          <p v-if="dialogData.memberName">{{dialogData.memberName}}</p>
        </div>
        <img class="card" :src="dialogData.packageImage ? dialogData.packageImage : 'https://ebuyimg.e-mallchina.com/olvp/autocard.png'">
        <p>{{dialogData.description}}</p>
      </div>
    </van-dialog>
    <!-- 短链弹窗 -->
    <van-dialog v-model="copyDialog" confirm-button-text="OK" cancel-button-text="Don't Remind Me Again" :close-on-click-overlay="true" :close-on-popstate="true">
      <div class="tips-content">
        <div class="txt">
          <p class="copy">Below url of your gift has been copied, please paste to SMS, Email, Wechat, Line or other channel to share.</p>
          <div class="url-link gray">{{shortLink}}</div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      active: '',
      giftDialog: false,
      copyDialog: false,
      getListParams: {
        token: '',
        pageNumber: 1,
        pageSize: 500
      },
      orderListParams: {
        token: '',
        pageNumber: 1,
        pageSize: 10,
        condition: {
          listStatus: ''
          // orderStatus: ''
        }
      },
      notGiftedItems: [],
      receiveItems: [],
      transferItems: [],
      loading: false,
      finished: false,
      totalPageR: 0,
      totalPageT: 0,
      totalPageO: 0,
      dialogData: {},
      shortLink: '',
      listLoading: true,
      localMemberId: ''
    }
  },
  filters: {
    status (s) {
      switch (s) {
        case 'Init':
          return 'Unpaid'
        case 'Paid':
          return 'Processing'
        default:
          return 'Not Gifted'
      }
    },
    packageStatus (p) {
      switch (p) {
        case 'DELIVERING':
          return 'Gifting'
        case 'SUCCESS':
          return 'Gifted'
        case 'cancel':
          return '--'
      }
    }
  },
  created () {
    this.active = this.$route.query.active || 'notGift'
    let token = this.$util.storageGet('local', 'token')
    this.localMemberId = this.$util.storageGet('local', 'memberId') || ''
    if (token) {
      this.getListParams.token = token
      this.orderListParams.token = token
      this.$cux.loading()
      this.loadPaid().then(() => {
        this.loadOrderList()
      })
      this.loadReceiveList()
      this.loadTransferList()
    }
  },
  methods: {
    // 订单列表
    getOrderList (params) {
      return this.$http.post('/olvp/getOrderList', 'getOrderList', params, false, false, false, false)
    },
    // 获取我收到的
    getMyReceive (params) {
      return this.$http.post('/olvp/getMyReceive', 'getMyReceive', params, false, false)
    },
    // 获取我送出的
    getMyTransfer (params) {
      return this.$http.post('/olvp/getMyTransfer', 'getMyTransfer', params, false, false)
    },
    onCheckTap (item) {
      // this.$router.push(`/orderDetail?type=${type}&orderId=${id}`)
      this.dialogData = item
      this.giftDialog = true
    },
    checkCoupons () {
      this.$router.push(`/couponDetail?type=package&packageId=${this.dialogData.packageId}&active=received`)
    },
    changeTab (e) {
      this.active = e
    },
    loadReceiveList () {
      return new Promise(resolve => {
        this.getMyReceive(this.getListParams).then((d) => {
          this.$cux.loadend()
          if (d.success) {
            const data = d.content
            this.totalPageR = Math.ceil(data.totalSize / data.pageSize)
            this.receiveItems = data.dataList
            if (data.totalSize > 0) {
              this.receiveItems.map((v) => {
                if (v.packageName === 'VoucherTransfer') {
                  v.orderName = 'A Gift Coupon'
                } else {
                  v.orderName = Number(v.quantity) === 1 ? `Including ${v.quantity} Gift` : `Including ${v.quantity} Gifts`
                }
                if (v.memberId === this.$util.storageGet('local', 'memberId')) {
                  v.from = 'From myself'
                } else {
                  v.from = v.memberName ? 'From ' + v.memberName : 'From others'
                }
              })
            }
            this.listLoading = false
          }
          resolve()
        })
      })
    },
    loadTransferList () {
      return new Promise(resolve => {
        this.getMyTransfer(this.getListParams).then((d) => {
          this.$cux.loadend()
          if (d.success) {
            const data = d.content
            this.totalPageT = Math.ceil(data.totalSize / data.pageSize)
            this.transferItems = data.dataList
            this.transferItems.map((v) => {
              if (v.packageName === 'VoucherTransfer') {
                v.orderName = 'A Gift Coupon'
              } else {
                v.orderName = Number(v.quantity) === 1 ? `Including ${v.quantity} Gift` : `Including ${v.quantity} Gifts`
              }
            })
          }
          resolve()
        })
      })
    },
    loadPaid () {
      return new Promise(resolve => {
        const params = {
          token: this.$util.storageGet('local', 'token'),
          pageNumber: 1,
          pageSize: 100,
          condition: {
            listStatus: 'Free'
            // orderStatus: 'Paid'
          }
        }
        this.getOrderList(params).then((d) => {
          if (d.success) {
            const data = d.content
            this.notGiftedItems = data.dataList
            this.notGiftedItems.map((v) => {
              const name = v.orderName.split(';')
              v.orderName = name.length === 1 ? `Including ${name.length} Gift` : `Including ${name.length} Gifts`
            })
          }
          resolve()
        })
      })
    },
    loadOrderList () {
      this.orderListParams.condition.listStatus = 'Visible'
      // this.orderListParams.condition.orderStatus = 'Complete'
      return new Promise(resolve => {
        this.getOrderList(this.orderListParams).then((d) => {
          this.$cux.loadend()
          this.loading = false
          if (d.success) {
            const data = d.content
            this.totalPageO = Math.ceil(data.totalSize / data.pageSize)
            this.notGiftedItems = this.notGiftedItems.concat(data.dataList)
            this.notGiftedItems.map((v) => {
              const name = v.orderName.split(';')
              v.orderName = name.length === 1 ? `Including ${name.length} Gift` : `Including ${name.length} Gifts`
            })
            if (data.dataList.length === 0 || this.totalPageO === 1) {
              this.finished = true
            }
          } else {
            this.finished = true
          }
          resolve()
        })
      })
    },
    onLoad () {
      if (this.active === 'notGift' && this.orderListParams.condition.listStatus === 'Visible') {
      // if (this.active === 'notGift' && this.orderListParams.condition.listStatus === 'Complete') {
        this.orderListParams.pageNumber++
        this.loadOrderList().then(() => {
          this.loading = false
        })
      }
    },
    goBack () {
      this.$router.replace('home')
    },
    // 复制短链
    onCopyTap (e) {
      this.shortLink = e
      let self = this
      let clipboard = new this.$clipboard('.copytext')
      clipboard.on('success', function () {
        self.copyDialog = true
      })
      clipboard.on('error', function () {
        // console.log('复制失败')
      })
    },
    onOrderTap (t, id, page) {
      switch (t) {
        case 'gift':
          this.$util.storageDel('session', 'giftImg')
          this.$util.storageDel('session', 'giftDesc')
          this.$router.push(`/giveFriends?status=success&from=order&orderId=${id}`)
          break
        case 'detail':
          this.$router.push(`/orderDetail?type=check&orderId=${id}&active=${page}`)
          break
      }
    }
  }
}
</script>

<style lang="scss">
  .my-gift {
    width: 100%;
    height: 100%;
    .van-image {
      border-radius: 4px;
      overflow: hidden;
    }
    .tips-content {
      padding: 30px 20px;
      overflow: hidden;
      .txt {
        .copy {
          line-height: 20px;
        }
        .url-link {
          padding: 10px;
          text-align: center;
          background: #f5f5f5;
          margin-top: 20px;
          border-radius: 3px;
        }
      }
    }
    .gift-dialog {
      padding: 15px;
      .friend {
        img {
          width: 30px;
          height: 30px;
          margin-right: 5px;
        }
      }
      .card {
        margin: 15px 0;
        border-radius: 5px;
        box-shadow: 0 2px 8px #ccc;
      }
    }
    .van-card {
      font-size: 14px;
      padding: 35px 0 15px 0;
      background-color: #fff;
      border-bottom: 1px dashed #ccc;
      &:not(:first-child) {
        margin-top: 1px;
      }
    }
    // .van-list .van-card {
    //   padding-top: 15px;
    // }
    .van-card__title {
      font-size: 17px;
      margin-top: 5px;
      margin-bottom: 5px;
    }
    .van-card__thumb {
      width: 110px;
      height: 65.6px;
      border-radius: 8px;
      box-shadow: 0 2px 8px #ccc;
      margin-right: 12px;
      .van-card__tag {
        width: 150px;
        top: -25px;
        background: #fff;
        .van-tag {
          font-size: 15px;
          color: #388BFF;
          padding: 0;
        }
        .van-tag--danger {
          background-color: transparent;
        }
      }
    }
    .van-card__content {
      min-height: 65.6px;
      margin-bottom: 10px;
    }
    .van-card__content .gray {
      margin: 5px 0;
    }
    .van-loading {
      text-align: center
    }
    .title {
      font-size: 16px;
      padding: 15px 20px 8px 20px;
      border-bottom: 1px solid #f5f5f5;
      .h-ico {
        width: 25px;
        height: 25px;
        margin-left: 15px;
      }
    }

    .nothing {
      padding: 50px 0;
      text-align: center;
    }
    .list.notag .van-card{
      padding-top:15px;
    }
    .list {
      padding: 15px 15px 100px 15px;
      background: #fff;
      .van-button {
        width: 80px;
      }

      .item:last-child {
        border: none;
      }

      .item {
        padding: 15px 0;
        border-bottom: 1px dashed #ccc;

        .fx-end {
          margin-top: 5px;
        }

        .time {
          margin-bottom: 3px;
        }

        .status {
          font-size: 16px;
          margin-bottom: 10px;
        }

        .goods-logo {
          width: 110px;
          height: 100%;
          margin-right: 12px;
          border-radius: 5px;
          box-shadow: 0 2px 8px #ccc;
        }

        .order-info {
          flex: 2;

          .name {
            font-size: 17px;
            margin-bottom: 5px;
          }

          .red {
            font-size: 18px;
          }
        }
      }
    }
    .van-multi-ellipsis--l2, .van-multi-ellipsis--l3 {
      overflow: visible !important;
    }
    .the-end {
      color: #969799;
      font-size: 14px;
      line-height: 50px;
      text-align: center;
    }
  }
</style>
